import type { Ref, SelectHTMLAttributes } from "react";
import { cx } from "../../lib/cx";

export type SelectProps = {
  invalid?: boolean;
  ref?: Ref<HTMLSelectElement>;
} & SelectHTMLAttributes<HTMLSelectElement>;

export const Select = ({ invalid = false, className, children, ref, ...rest }: SelectProps) => (
  <div data-state={invalid ? "error" : "default"} className={className}>
    <select ref={ref} className={cx("form-select", invalid && "is-invalid")} {...rest}>
      {children}
    </select>
  </div>
);
